import React from 'react';
import { connect } from 'react-redux';
import { shape, bool, string } from 'prop-types';
import { hasPermissionToView } from './authUtils';
import StatusError from '../StatusError/StatusError';

const Authorization = allowedRoles => WrappedComponent => {
  class WithAuthorization extends React.Component {
    static propTypes = {
      permissions: shape({
        globalAdmin: bool,
        groupAdmin: bool,
        siteAdmin: bool,
        superAdmin: bool,
        readOnlyUser: bool,
        restrictedUser: bool,
        regularUser: bool,
        reportViewUser: bool
      }),
      orgCode: string
    };

    render() {
      const { permissions, orgCode } = this.props;
      const hasPermission = hasPermissionToView(allowedRoles, permissions);
      if (hasPermission) {
        return <WrappedComponent {...this.props} />;
      } else {
        const url = `/view/o/${orgCode}/mp/`;
        const _onClick = () => {};
        return (
          <StatusError
            showFooter={false}
            message="You are not authorized to view this page."
            url={url}
            onClick={_onClick}
          />
        );
      }
    }
  }

  const mapStateToProps = ({ session, config }) => ({
    permissions: session.user.rights,
    orgCode: config.orgCode
  });

  return connect(mapStateToProps)(WithAuthorization);
};

export const SuperAdmin = Authorization(['superAdmin']);
export const GroupAdmin = Authorization(['groupAdmin, superAdmin']);
export const SiteAdmin = Authorization(['siteAdmin', 'superAdmin']);
export const RegularUser = Authorization(['regularUser', 'groupAdmin', 'siteAdmin', 'superAdmin']);
export const ReadOnlyUser = Authorization(['readOnlyUser', 'regularUser', 'groupAdmin', 'siteAdmin', 'superAdmin']);
export const RestrictedUser = Authorization([
  'restrictedUser',
  'readOnlyUser',
  'regularUser',
  'groupAdmin',
  'superAdmin'
]);
export const ReportViewer = Authorization([
  'reportViewUser',
  'readOnlyUser',
  'regularUser',
  'groupAdmin',
  'superAdmin'
]);
